import { Box, Slide, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AccountType,
  Color,
  FontStyle,
  MediaQuery,
  navPaddingTop,
  READY_EMPLOYER,
  Slug,
} from "../constants";
import { logout } from "../service/AuthService";
import YouPopup from "./YouPopup";
import Hamburger from "./Hamburger";
import VerifyEmailBar from "./VerifyEmailBar";
import { userFinishedTutorial } from "../service/CookieService";
import * as apiService from "../service/ApiService";
import UploadResumeBar from "./UploadResumeBar";

const styles = {
  container: {
    // backgroundColor: "transparent",
    backgroundColor: "#fffd",
    // padding: "16px",
    py: "16px",
    px: { xs: "16px", md: "32px" },
    position: "absolute",
    top: "0px",
    zIndex: "100",
    mx: "auto",
    width: "100%",
    // boxShadow: "2px 2px 8px 0 rgb(0 0 0 / 26%)",
    boxShadow: "2px 2px 8px rgb(0 0 0 / 22%)",
  },
  inner: {
    width: "100%",
    // maxWidth: "1200px",
    px: "0rem",
    position: "relative",
  },
  logo: {
    ...FontStyle.logo,
    fontSize: { xs: "32px", sm: "40px" },
    // fontSize: '26px',
    cursor: "pointer",
    paddingRight: { xs: 0, sm: "10px" },
    position: "relative",
  },
  empty: {
    width: "100vw",
  },
  links: {
    // width: "100vw",
    width: "100%",
    height: "100%",
    maxWidth: "650px",
    fontSize: "16px",
    // px: { xs: 'rem', sm: 0 }
    paddingRight: { xs: "0rem", sm: 0 },
    // paddingRight: { xs: '1rem', md: '4rem' },
  },
  link: {
    // ...FontStyle.menuButton,
    ...FontStyle.headingBody,
    cursor: "pointer",
    color: "black",
    // height: "45px",
    "&:hover": {
      textDecoration: "underline",
    },
    textDecoration: "none",
  },
  ahref: { color: "inherit", textDecoration: "inherit", fontWeight: "inherit" },
  linksFromHamburger: {
    position: "absolute",
    // top: "5.375rem",
    top: navPaddingTop,
    height: "100vh",
    width: "100vw",
    // backgroundColor: Color.primary,
    backgroundColor: "white",
    left: "0px",
    // bottom: '0px',
    padding: "1rem",
    fontSize: "1.73rem",
  },
  buttonsRow: {
    minWidth: "fit-content",
  },
  buttonBasic: {
    ...FontStyle.menuButton,
    cursor: "pointer",
    fontSize: { xs: "14px", sm: "16px" },
    px: "1rem",
    py: "0.5rem",
    borderRadius: "4px",
    transition: "all 0.2s ease-in-out 0s",
  },
  buttonOutlined: (whiteText) => {
    return {
      border: "1px solid black",
      "&:hover": {
        backgroundColor: "black",
        color: whiteText ? "#fff" : Color.primary,
        boxShadow: "0px 0px 8px 0 rgb(0 0 0 / 26%)",
      },
    };
  },
  buttonNeonOutlined: {
    border: `1px solid ${Color.primary}`,
    color: Color.primary,
    "&:hover": {
      backgroundColor: Color.primary,
      color: "black",
      boxShadow: `0px 0px 8px 0 ${Color.primary}a6`,
    },
  },
  buttonContained: (whiteText) => {
    return {
      border: "1px solid black",
      backgroundColor: "black",
      color: whiteText ? "#fff" : Color.primary,
      "&:hover": {
        backgroundColor: "transparent",
        color: "black",
        boxShadow: "0px 0px 8px 0 rgb(0 0 0 / 26%)",
      },
    };
  },
  buttonNeonContained: {
    border: `1px solid ${Color.primary}`,
    backgroundColor: Color.primary,
    color: "black",
    "&:hover": {
      backgroundColor: "transparent",
      color: Color.primary,
      boxShadow: `0px 0px 8px 0 ${Color.primary}a6`,
    },
  },
};

const locToLinks = {
  [Slug.home]: [],
  // loggedIn: [
  //   { text: "Home", link: Slug.jobResults },
  //   { text: "Matches", link: Slug.jobResults },
  //   { text: "Explore", link: Slug.jobResults },
  // ],
};
const loggedInStandardLinks = [
  { text: "Home", link: Slug.jobResults },
  { text: "Matches", link: Slug.matchesOnly },
  { text: "University", link: Slug.education },
  READY_EMPLOYER
    ? {
        text: "Inbox",
        link: Slug.inbox,
        textFunc: ({ messages }) => {
          if (messages.numUnread) {
            return `Inbox (${messages.numUnread})`;
          }
          return "Inbox";
        },
      }
    : null,
  { text: "Preferences", link: Slug.surveyInitial },
];
const loggedInGigLinks = [
  { text: "Home", link: Slug.jobResults },
  { text: "Matches", link: Slug.matchesOnly },
  { text: "University", link: Slug.education },
  { text: "Survey", link: Slug.surveyGigInitial },
];

// artifacts from landing page, may become relevant later
const darkMode = false;
const whiteText = true;

const ribbonBackColor = "#5684B8";
const AdminRibbon = () => {
  return (
    <Box
      sx={{
        fontSize: "12px",
      }}>
      <span
        style={{
          borderColor: `${ribbonBackColor} ${ribbonBackColor} ${ribbonBackColor} transparent`,
          position: "relative",
          borderStyle: "solid",
          fontSize: 0,
          left: "5px",
          borderWidth: "10px",
        }}
      />
      <span
        style={{
          display: "inline-block",
          // height: "40px",
          paddingTop: "4px",
          paddingBottom: "4px",
          paddingLeft: "20px",
          paddingRight: "20px",
          color: "black",
          transform: "translateY(-0px)",
          // backgroundColor: Color.fettiLightBlue,
          // background-color: #0093E9;
          // backgroundImage: `linear-gradient(89deg, #0093E9 0%, ${Color.fettiLightBlue} 100%)`,
          // background-color: #8EC5FC;
          backgroundImage: `linear-gradient(62deg, #8EC5FC 0%, ${Color.fettiLightBlue} 100%)`,
        }}>
        SPECIALIST
      </span>
      <span
        style={{
          borderColor: `${ribbonBackColor} transparent ${ribbonBackColor} ${ribbonBackColor}`,
          position: "relative",
          zIndex: -1,
          borderStyle: "solid",
          fontSize: 0,
          right: "5px",
          borderWidth: "10px",
        }}
      />
    </Box>
  );
};

const LoggedInLinks = ({ isGig }) => {
  const navigate = useNavigate();
  const messages = useSelector((state) => state.messages);
  return (
    <Stack
      direction="row"
      sx={{
        ...styles.links,
      }}
      // spacing={{ xs: 3, sm: 4 }}
      justifyContent="space-around"
      alignItems="center">
      {(isGig ? loggedInGigLinks : loggedInStandardLinks).map(
        ({ text, link, textFunc }, i) => {
          return (
            <Stack
              sx={{
                ...styles.link,
              }}
              justifyContent="center"
              alignItems="center"
              key={i}>
              <a href={link} style={{ ...styles.ahref }}>
                {textFunc ? textFunc({ messages }) : text}
              </a>
            </Stack>
          );
        }
      )}
    </Stack>
  );
};
const TwoButtons = ({
  text1,
  click1,
  text2,
  click2,
  href1 = null,
  href2 = null,
}) => {
  const smScreen = useMediaQuery({ query: MediaQuery.sm });
  return (
    <Stack
      direction="row"
      sx={{
        ...styles.buttonsRow,
      }}
      alignItems="center"
      spacing={smScreen ? { xs: 2, sm: 2 } : "8px"}>
      {href1 ? (
        <a href={href1} style={{ ...styles.ahref }}>
          <Box
            sx={{
              ...styles.buttonBasic,
              ...(darkMode
                ? styles.buttonNeonOutlined
                : styles.buttonOutlined(whiteText)),
            }}
            onClick={click1}>
            {text1}
          </Box>
        </a>
      ) : (
        <Box
          sx={{
            ...styles.buttonBasic,
            ...(darkMode
              ? styles.buttonNeonOutlined
              : styles.buttonOutlined(whiteText)),
          }}
          onClick={click1}>
          {text1}
        </Box>
      )}
      {href2 ? (
        <a href={href2} style={{ ...styles.ahref }}>
          <Box
            sx={{
              ...styles.buttonBasic,
              ...(darkMode
                ? styles.buttonNeonContained
                : styles.buttonContained(whiteText)),
            }}
            onClick={click2}>
            {text2}
          </Box>
        </a>
      ) : (
        <Box
          sx={{
            ...styles.buttonBasic,
            ...(darkMode
              ? styles.buttonNeonContained
              : styles.buttonContained(whiteText)),
          }}
          onClick={click2}>
          {text2}
        </Box>
      )}
    </Stack>
  );
};

const NavBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [linksInBar, setLinksInBar] = React.useState(locToLinks[Slug.home]);
  const smScreen = useMediaQuery({ query: MediaQuery.sm });
  const smUniScreen = useMediaQuery({ query: "screen and (max-width: 852px)" }); // diff threshold after adding 'university' link
  const mdScreen = useMediaQuery({ query: MediaQuery.md });
  const [hamburgerOpen, setHamburgerOpen] = React.useState(false);
  const [showProfileLinks, setShowProfileLinks] = React.useState(false);
  const loggedIn = auth.testing
    ? true
    : auth.accountData.loginToken !== null &&
      auth.accountData.contactInfo !== null;
  const isGig = auth.accountData.accountType === AccountType.gig;
  const isAdmin = auth.accountData.isAdmin;
  const inAdminPage = location.pathname.includes(Slug.admin);
  const inInbox = location.pathname.includes(Slug.inbox);
  //   const loggedIn = true;
  useEffect(() => {
    setHamburgerOpen(false);
    if (locToLinks[location.pathname] === undefined) {
      setLinksInBar(locToLinks[Slug.home]);
    } else {
      setLinksInBar(locToLinks[location.pathname]);
    }
  }, [location.pathname]);

  const apply = useSelector((state) => state.apply);
  const resumeList = apply.serverData.resumes;
  const [loadedResumes, setLoadedResumes] = React.useState(false);
  useEffect(() => {
    // load resume list when entering this page
    if (!loggedIn) return;
    if (loadedResumes) return;
    console.log("loading resume data from navbar", resumeList);
    apiService.getResumeUploads(
      dispatch,
      { ...auth.accountData },
      {
        handleSuccess: () => {
          setLoadedResumes(true);
        },
      }
    );
  }, [loggedIn, loadedResumes]);
  const showVerifyBar =
    loggedIn &&
    !auth.accountData.verified &&
    userFinishedTutorial() &&
    !location.pathname.includes(Slug.sentVerificationEmail);
  const showResumeBar =
    loggedIn && loadedResumes && resumeList.length === 0 && !isGig;

  return (
    <Stack
      direction="row"
      sx={{
        ...styles.container,
        ...(smUniScreen && { px: 1.5 }),
        ...(inAdminPage && {
          backgroundColor: "transparent",
          // backgroundImage:
          //   "radial-gradient( circle 200px at 20% 50%,  rgba(190,213,255,0.95) 0%, rgba(190,213,255,0.4) 79% )",
        }),
        ...(inInbox && {
          boxShadow: "0px 2px 4px rgb(0 0 0 / 10%)",
        }),
      }}
      justifyContent="center"
      alignItems="center">
      <Stack
        // direction={loggedIn ? { xs: 'column', sm: 'row' } : 'row'}
        direction="row"
        sx={styles.inner}
        justifyContent="space-between"
        alignItems="center">
        {/* onClick={() => navigate(Slug.surveyInitial)} */}
        <a
          href={isAdmin ? Slug.admin : Slug.surveyInitial}
          style={{ ...styles.ahref }}>
          <Box sx={styles.logo}>
            Fetti
            {isAdmin === 1 && (
              <Box
                sx={{
                  position: "absolute",
                  left: { xs: "-40px", sm: "-33px" },
                  top: { xs: "34px", sm: "43px" },
                  transform: { xs: "scale(0.5)", sm: "scale(0.6)" },
                }}>
                <AdminRibbon />
              </Box>
            )}
            {/* account type: {auth.accountData.accountType} */}
          </Box>
        </a>
        {loggedIn && mdScreen && <LoggedInLinks isGig={isGig} />}
        {loggedIn && mdScreen && (
          <TwoButtons
            text1="Log Out"
            click1={() => logout(navigate, dispatch)}
            text2="Settings"
            href2={Slug.settings}
            // click2={() => navigate(Slug.settings)}
          />
        )}
        {loggedIn && !mdScreen && (
          <>
            <Hamburger open={hamburgerOpen} setOpen={setHamburgerOpen} />
            <Slide direction="up" in={hamburgerOpen} mountOnEnter unmountOnExit>
              <Stack
                direction="column"
                sx={{
                  ...styles.linksFromHamburger,
                  // display: mdScreen ? "none" : "flex",
                  ...(darkMode && { backgroundColor: "black" }),
                }}
                spacing={2}>
                {(isGig ? loggedInGigLinks : loggedInStandardLinks).map(
                  ({ text, link }, i) => {
                    return (
                      <Box sx={styles.link} key={i}>
                        <a style={styles.ahref} href={link}>
                          {text}
                        </a>
                      </Box>
                    );
                  }
                )}
                <Box
                  sx={styles.link}
                  onClick={() => logout(navigate, dispatch)}>
                  Log Out
                </Box>
                <Box sx={styles.link} onClick={() => navigate(Slug.settings)}>
                  Settings
                </Box>
              </Stack>
            </Slide>
          </>
        )}
        {!loggedIn && (
          <TwoButtons
            text1="Sign Up"
            href1={Slug.surveyInitial}
            // click1={() => navigate(Slug.surveyInitial)}
            text2="Sign In"
            href2={Slug.login}
            // click2={() => navigate(Slug.login)}
          />
        )}
        {/* {READY_EMPLOYER && (
          <Box
            sx={{
              position: "absolute",
              left: "100px",
              top: "18px",
              fontSize: "12px",
              ...FontStyle.body,
              color: "#0008",
              width: "50px",
              textAlign: "center",
              // backgroundColor: "white",
              // padding: "2px",
              // borderRadius: "4px",
              // zIndex: "100",
            }}>
            Employer Ready
          </Box>
        )} */}
      </Stack>
      {(showResumeBar || showVerifyBar) &&
        !location.pathname.includes("preferences") && (
          <Stack
            direction="column"
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              transform: "translate(0, 100%)",
              width: "100%",
              ...FontStyle.body,
              fontSize: "14px",
              textAlign: "center",
            }}>
            {showVerifyBar && !showResumeBar && <VerifyEmailBar />}
            {showResumeBar && <UploadResumeBar />}
          </Stack>
        )}
      {showProfileLinks && <YouPopup setShow={setShowProfileLinks} />}
    </Stack>
  );
};

export default NavBar;
